

import React, { useEffect, useRef } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import useQuery from 'hooks/useQuery';
import { CNPJ_MASK, CPF_MASK } from 'v3/utils/masks';

import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import Input from 'v3/components/Input';

function Filter({ fetchShippingCompanies }) {
  const query = useQuery();
  const navigate = useNavigate();
  const location = useLocation();

  const nameRef = useRef(null);
  const cgccpfRef = useRef(null);

  useEffect(() => {
    fetchShippingCompanies();
  }, [location.search]);

  function onFilterChange(key, value) {
    if (value) {
      query.set(key, value);
    } else {
      query.delete(key);
    }
  }

  useEffect(() => {
    function onPressedKey(e) {
      if (e.key === 'Enter') {
        navigate({ search: query.toString() });
      }
    }
    window.addEventListener('keyup', onPressedKey);

    return () => {
      window.removeEventListener('keyup', onPressedKey);
    };
  });

  useEffect(() => {
    if (nameRef.current) {
      nameRef.current.value = query.get('name');
    }
    if (cgccpfRef.current) {
      cgccpfRef.current.value = query.get('cgccpf');
    }
  }, [query.toString()]);

  function applyMask(rawValue, options) {
    const regex = new RegExp(options.placeholderChar, 'g');
    if (rawValue.replace(regex, '').length > CPF_MASK.length) {
      return CNPJ_MASK;
    }

    return CPF_MASK;
  }

  return (
    <Row className="mb-4 align-items-end">
      <Col md={6} xs={12}>
        <Input
          label="Transportadora"
          labelColor="#fff"
          placeholder="Digite o nome..."
          onChange={({ target }) => {
            onFilterChange('name', target.value);
          }}
          ref={nameRef}
        />
      </Col>
      <Col md={6} xs={12} className="d-flex align-items-end">
        <Input
          label="CPF/CNPJ"
          labelColor="#fff"
          placeholder="Digite o CPF ou CNPJ..."
          onChange={({ target }) => onFilterChange('cgccpf', target.value)}
          ref={cgccpfRef}
          masked
          guide={false}
          mask={applyMask}
          containerStyle={{ flex: 1 }}
        />
        <Button
          variant="success"
          onClick={() => navigate({ search: query.toString() })}
          style={{ marginLeft: 12, height: 44 }}
        >
          <Text type="regular" weight={500}>
            Filtrar
          </Text>
        </Button>
      </Col>
    </Row>
  );
}

export default Filter;
